import React from 'react'

import { useTranslation } from 'react-i18next'

import X from '@/presentation/assets/svg/X.svg'
import Button from '@/presentation/components/Button'

interface DevicePermissionPopupProps {
  onCancel: () => void
}

const DevicePermissionPopup: React.FC<DevicePermissionPopupProps> = ({
  onCancel
}) => {
  const { t } = useTranslation()

  return (
    <div
      onClick={onCancel}
      className="fixed inset-0 flex items-center justify-center bg-[#70707059] px-4"
    >
      <div
        className="flex max-w-[460px] flex-col rounded-lg bg-white p-4 px-6"
        onClick={event => event.stopPropagation()}
      >
        <div className="mb-1 flex items-center justify-between">
          <span className="text-lg text-gray-700">
            {t('ATTENTION', 'Atenção!')}
          </span>

          <img src={X} onClick={onCancel} className="cursor-pointer" />
        </div>

        <hr className="mb-4" />

        <span className="mb-4 block text-justify text-gray-700">
          {t(
            'BEFORE_SENDING_PHOTOS',
            'Antes de enviar as fotos da contestação certifique-se que o navegador (Safari, Google Chrome, Firefox etc) do seu dispositivo está com as devidas permissões para poder acessar ou tirar fotos.'
          )}
        </span>

        <Button className="mb-4 w-full" onClick={onCancel} colored>
          {t('UNDERSTOOD', 'Entendido')}
        </Button>
      </div>
    </div>
  )
}

export default DevicePermissionPopup
